<template>
  <div>
    <div class="row">
      <div class="col-md-6  grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h6 class="card-title float-start">Tempat & Tanggal</h6>
          </div>
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-3 col-form-label">Tempat</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" :id="this.$dynamicId()" placeholder="Tempat"
                  v-model="forms.kotaTtd" @input="forceUpper($event, forms, 'kotaTtd')">

                  <div v-if="this.forms.kotaTtd == null || this.forms?.kotaTtd == ''">
                    <div class="alert alert-danger" style="padding:5px;"
                        role="alert">
                        <i data-feather="alert-circle"></i>
                        Tempat Kosong
                    </div>
                  </div>

                <div v-if="errors.kotaTtd">
                  <div v-for="error in errors.kotaTtd" :key="error" class="alert alert-primary" role="alert">
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-3 col-form-label">Tanggal</label>
              <div class="col-sm-9">
                <date-picker v-model="forms.tanggalTtd" placeholder="YYYY-MM-DD" format="YYYY-MM-DD" valueType="format"
                  type="date" required></date-picker>

                  <div v-if="this.forms.tanggalTtd == null || this.forms?.tanggalTtd == ''">
                    <div class="alert alert-danger" style="padding:5px;"
                        role="alert">
                        <i data-feather="alert-circle"></i>
                        Tanggal Kosong
                    </div>
                  </div>

                <div v-if="errors.tanggalTtd">
                  <div v-for="error in errors.tanggalTtd" :key="error" class="alert alert-primary" role="alert">
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="col-md-6  grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h6 class="card-title float-start">Nama</h6>
          </div>
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-3 col-form-label">Nama</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" :id="this.$dynamicId()" placeholder="Nama" @input="forceUpper($event, forms, 'namaTtd')"
                  v-model="forms.namaTtd">

                  <div v-if="this.forms.namaTtd == null || this.forms?.namaTtd == ''">
                    <div class="alert alert-danger" style="padding:5px;"
                        role="alert">
                        <i data-feather="alert-circle"></i>
                        Nama Kosong
                    </div>
                  </div>

                <div v-if="errors.namaTtd">
                  <div v-for="error in errors.namaTtd" :key="error" class="alert alert-primary" role="alert">
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-3 col-form-label">Jabatan</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" :id="this.$dynamicId()" placeholder="Jabatan" @input="forceUpper($event, forms, 'jabatanTtd')"
                  v-model="forms.jabatanTtd">

                  <div v-if="this.forms.jabatanTtd == null || this.forms?.jabatanTtd == ''">
                    <div class="alert alert-danger" style="padding:5px;"
                        role="alert">
                        <i data-feather="alert-circle"></i>
                        Jabatan Kosong
                    </div>
                  </div>

                <div v-if="errors.jabatanTtd">
                  <div v-for="error in errors.jabatanTtd" :key="error" class="alert alert-primary" role="alert">
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-md-12">

        <a class="nav-link" id="entitas-line-tab" data-toggle="tab" href="#entitas" role="tab" aria-controls="disabled"
          aria-selected="false">
          <button class="btn btn-info float-end btn-sm" @click="submitData()" type="button"  :disabled="isLoading">
            
            <div v-show="isLoading">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading...
            </div>
            <div v-show="!isLoading">
              <i class="link-icon mdi mdi-content-save"></i>
              {{ $t("save_change_txt") + " Pernyataan" }}
            </div>
          </button>
        </a>

      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/id';
export default {
  name: "CeisaImporPernyataan",
  props: {
    propsData: { type: [Object, Array] }
  },
  components: {
    DatePicker
  },
  data() {
    return {
      errors: [],
      isLoading: false,
      forms: {},
    }
  },
  methods: {
    forceUpper(e, obj, prop) {
      const start = e.target.selectionStart
      e.target.value = e.target.value.toUpperCase()
      this.$set(obj, prop, e.target.value)
      e.target.setSelectionRange(start, start)
    },
    submitData() {
      this.isLoading = true;
      var send = {
        document_id: this.forms.document_id,
        namaTtd: this.forms.namaTtd,
        tanggalTtd: this.forms.tanggalTtd,
        jabatanTtd: this.forms.jabatanTtd,
        kotaTtd: this.forms.kotaTtd,
      };

      const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-10";
      this.$http.post(baseURI, send, { timeout: 10000 }).then((response) => {
        this.loading();
        if (response.data.status === 200) {
          this.errors = [];
          this.success('Berhasil');
          this.$emit('updateData');
        } else {
          this.errors = response.data.errors;
          this.resultError(response.data.errors);
        }
      }).catch(error => {
        this.loading();
        if (error.code == "ECONNABORTED") {
          this.error("Please Check Your Internet Connection");
        }

        if (error.response) {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.resultError(error.response.data.errors);
          } else if (error.response.status === 401) {
            this.logout();
          } else if (error.response.status === 403) {
            this.$router.push("/authorized-error");
          } else if (error.response.status === 500) {
            this.$router.push('/server-error');
          } else {
            this.$router.push('/page-not-found');
          }
        }
      });
    },
    logout() {

      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        console.log(response);

      });

      this.$logoutUser();
      window.location.href = '/';
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  watch: {
    propsData: function (newVal) {
      this.forms = newVal;
    },
    forms: function (newVal) {
      this.$emit('formUpdate', newVal);
    },
  },
}
</script>

<style></style>